import React, { Component } from 'react';
import _ from 'lodash';
import Joyride from 'react-joyride';
import { EDITOR_DESKTOP_LEFT_BAR_MENU_ELEMENTS_ID, EDITOR_DESKTOP_PROPERTIES_MENU_ID, VIEW_MODES_SWITCH_ID, DESKTOP_ELEMENT_CONTROLS_ID, EDITOR_SAVE_BUTTONS_ID, PREVIEW_BUTTON_ID, EDITOR_UNDO_REDO_BUTTONS_ID, WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID } from 'crazyEditor/core/constants/editorConstants';

require('./GlobalStyles/JoyrideCSS.scss');

const INTERCOM_ELEMENT_CLASS_NAME = 'intercom-launcher-frame';
const SELECT_DESIGN_ELEMENTS_BEACON_ID = 0;
const YOUR_PAGE_BEACON_ID = 1;
const EDIT_ELEMENTS_BEACON_ID = 2;
const SWITCH_EDITOR_VIEWS_BEACON_ID = 3;
const TOP_RIGHT_MENU_BEACON_ID = 4;
const RIGHT_MENU_BEACON_ID = 5;
export const BEACONS = {
  [SELECT_DESIGN_ELEMENTS_BEACON_ID]: {
    steps: [
      {
        title: 'Design Elements',
        text: 'Click on Text or Elements and you’ll see all of your customizable features: Galleries, Images, Tabs, and more to add to your listing’s template.',
        selector: `#${EDITOR_DESKTOP_LEFT_BAR_MENU_ELEMENTS_ID}`,
        position: 'right',
        isFixed: true,
        beaconId: SELECT_DESIGN_ELEMENTS_BEACON_ID,
      }
    ],
    ref: null,
  },
  [YOUR_PAGE_BEACON_ID]: {
    steps: [
      {
        title: 'This is your page',
        text: 'This is where your ideas come to life. Click and drag any elements in and around this space to create your ultimate template.',
        // text: 'This is your page man!',
        selector: '#desktop-view',
        position: 'left',
        beaconId: YOUR_PAGE_BEACON_ID,
        style: {
          width: 550,
          beacon: {
            offsetX: -650
          }
        }
      }
    ],
    ref: null,
  },
  [EDIT_ELEMENTS_BEACON_ID]: {
    steps: [
      {
        title: 'Edit Elements',
        text: 'Once you select an element, you can edit its properties like color, border, font etc. into your own style with this toolbar.',
        selector: `#${EDITOR_DESKTOP_PROPERTIES_MENU_ID}`,
        position: 'bottom',
        isFixed: true,
        beaconId: EDIT_ELEMENTS_BEACON_ID,
      }
    ],
    ref: null,
  },
  [SWITCH_EDITOR_VIEWS_BEACON_ID]: {
    steps: [
      {
        title: 'Desktop & Mobile Views',
        text: 'Click here to switch between mobile and desktop views to make sure it looks just right in both versions. <br/><br/>Don’t forget to turn on the “Make listing mobile friendly” switch once you’re happy with the mobile version of your design.',
        selector: `#${VIEW_MODES_SWITCH_ID}`,
        position: 'left',
        isFixed: true,
        beaconId: SWITCH_EDITOR_VIEWS_BEACON_ID,
        style: {
          beacon: {
            offsetX: 20
          }
        }
      }
    ],
    ref: null,
  },
  [TOP_RIGHT_MENU_BEACON_ID]: {
    steps: [
      {
        title: 'Undo and Redo',
        text: 'Don’t be afraid to make mistakes! You can always undo or redo what you’ve just done using these buttons.',
        selector: `#${EDITOR_UNDO_REDO_BUTTONS_ID}`,
        position: 'bottom',
        isFixed: true,
        beaconId: TOP_RIGHT_MENU_BEACON_ID,
        style: {
          width: 350,
        },
      },
      {
        title: 'Preview',
        text: 'Get a sneak peek of what your listing would look like on a desktop and mobile before you go live.',
        selector: `#${PREVIEW_BUTTON_ID}`,
        position: 'bottom',
        isFixed: true,
        beaconId: TOP_RIGHT_MENU_BEACON_ID,
        style: {
          width: 350,
        },
      },
      {
        title: 'Save and Publish',
        text: 'Once you’re happy, click “Save and Publish” to go live with your listing template. Click the small arrow on the right to see additional saving options.',
        selector: `#${EDITOR_SAVE_BUTTONS_ID}`,
        position: 'bottom',
        isFixed: true,
        beaconId: TOP_RIGHT_MENU_BEACON_ID,
        style: {
          width: 350,
        },
      }
    ],
    ref: null,
    type: 'continuous',
  },
  [RIGHT_MENU_BEACON_ID]: {
    steps: [
      {
        title: 'Precise Work',
        text: 'Do you want a template with pixel perfect precision? Control the exact size and position of each element with this toolbar on the right.',
        selector: `#${DESKTOP_ELEMENT_CONTROLS_ID}`,
        position: 'left',
        isFixed: true,
        beaconId: RIGHT_MENU_BEACON_ID,
      }
    ],
    ref: null,
  },
};

const welcomeStep = {
  title: 'Welcome to CrazyLister editor',
  text: 'Here you’ll be able to customize listing templates to your exact needs. <br/>For a quick tour of the editing features click “Next.”',
  selector: '#welcome-step-anchor',
  isFixed: true,
  style: {
    arrow: {
      display: 'none',
    },
  },
};

const intercomStep = {
  title: 'Live chat',
  text: 'Have a question? We’re here for you with live chat support at the click of a button. We’re always happy to help!',
  selector: `.${INTERCOM_ELEMENT_CLASS_NAME}`,
  position: 'top-right',
  isFixed: true,
};

const continueExploringStep = {
  title: 'Explore at your own pace',
  text: 'We placed some markers around the window to hold your hand through your first steps in the editor. Click the markers for more information.',
  selector: '.joyride-beacon',
  position: 'right',
  isFixed: true,
  lastStartingStep: true,
};

export default class EditorWalkThrough extends Component {
  state = {
    showWalkThrough: false,
    isIntercomLoaded: false,
    lastStartingStepVisited: false,
    continueExploring: false,
    beacons: null,
  };

  componentDidMount() {
    this.beaconsLeftToShow = {};
    this.getBeaconsToShow();

    const intercomInterval = setInterval(() => {
      const {isIntercomLoaded, lastStartingStepVisited} = this.state;
      if (document.querySelector(`.${INTERCOM_ELEMENT_CLASS_NAME}`) && !isIntercomLoaded && !lastStartingStepVisited) {
        this.setState({isIntercomLoaded: true});
        clearInterval(intercomInterval);
      }
    }, 100);
    setTimeout(() => clearInterval(intercomInterval), 10000);
  }

  getBeaconsToShow = () => {
    const {beaconsToShow} = this.props;
    const updatedBeacons = {};

    if (beaconsToShow) {
      this.beaconsLeftToShow = beaconsToShow;
      _.forEach(BEACONS, (beacon, beaconId) => {
        updatedBeacons[beaconId] = {
          showBeacon: this.beaconsLeftToShow && this.beaconsLeftToShow[beaconId],
        };
      });
      this.setState({beacons: updatedBeacons});
    } else {
      _.forEach(BEACONS, (beacon, beaconId) => {
        updatedBeacons[beaconId] = {
          showBeacon: false,
        };
        this.beaconsLeftToShow[beaconId] = true;
      });
      this.setState({showWalkThrough: true, beacons: updatedBeacons});
    }
  };

  getBeaconsLeftToShowIds = () => {
    const beaconsIds = {};
    _.forEach(this.beaconsLeftToShow, (showBeacon, beaconId) => {
      if (showBeacon) {
        beaconsIds[beaconId] = _.parseInt(beaconId);
      }
    });
    return beaconsIds;
  };

  showBeacons = (beaconIdsToShow) => {
    const {beacons} = this.state;
    const updatedBeacons = {};
    _.forEach(beacons, (beacon, beaconId) => {
      const numBeaconId = _.parseInt(beaconId);
      updatedBeacons[numBeaconId] = _.merge({}, beacons[numBeaconId], {showBeacon: _.includes(beaconIdsToShow, numBeaconId)});
    });
    return updatedBeacons;
  };

  hideBeacons = (beaconIdsToHide) => {
    const {beacons} = this.state;
    const updatedBeacons = _.merge({}, beacons);
    _.forEach(beaconIdsToHide, (beaconId) => {
      updatedBeacons[beaconId] = _.merge({}, beacons[beaconId], {showBeacon: false});
    });
    return updatedBeacons;
  };

  startingJoyrideCallback = (joyrideState) => {
    this.handleSkipIfNeeded(joyrideState);
    if ((joyrideState.type === 'finished' && !joyrideState.isTourSkipped) || joyrideState.action === 'close') {
      localStorage.setItem(WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID, JSON.stringify(this.beaconsLeftToShow));
      this.setState({showWalkThrough: false, lastStartingStepVisited: true, continueExploring: true, beacons: this.showBeacons(this.getBeaconsLeftToShowIds())});
    }
  };

  toggleBeacons = (joyrideState) => {
    this.handleSkipIfNeeded(joyrideState);
    const {beacons} = this.state;
    if (joyrideState.type === 'beacon:trigger') {
      this.setState({beacons: _.merge({}, beacons, this.hideBeacons(_.omit(this.getBeaconsLeftToShowIds(), [joyrideState.step.beaconId])))});
    } else if ((joyrideState.type === 'finished' && !joyrideState.isTourSkipped) || joyrideState.action === 'close') {
      if (joyrideState.steps) {
        this.beaconsLeftToShow[joyrideState.steps[0].beaconId] = false;
      } else {
        this.beaconsLeftToShow[joyrideState.step.beaconId] = false;
      }
      localStorage.setItem(WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID, JSON.stringify(this.beaconsLeftToShow));
      this.setState({beacons: this.showBeacons(this.getBeaconsLeftToShowIds())});
    }
  };

  handleSkipIfNeeded(joyrideState) {
    if (joyrideState.isTourSkipped) {
      const {beacons} = this.state;
      this.setState({beacons: _.mapValues(beacons, beacon => ({...beacon, showBeacon: false}))});
      localStorage.setItem(WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID, JSON.stringify([]));
    }
  }

  render() {
    const {isIntercomLoaded, beacons, showWalkThrough, continueExploring} = this.state;

    const locale = {back: 'Back', close: 'Close', last: 'Next', next: 'Next', skip: 'Skip All'};
    return (
      <div>
        {showWalkThrough &&
          <Joyride
            ref={c => (this.startingJoyride = c)}
            steps={isIntercomLoaded ? [welcomeStep, intercomStep] : [welcomeStep]}
            run
            autoStart
            type="continuous"
            disableOverlay
            locale={locale}
            callback={this.startingJoyrideCallback}
            showSkipButton
          />
        }
        {continueExploring &&
          <Joyride
            ref={c => (this.continueExploringJoyride = c)}
            steps={[continueExploringStep]}
            run
            autoStart
            disableOverlay
            callback={this.startingJoyrideCallback}
            showSkipButton
            locale={locale}
          />
        }
        {_.map(BEACONS, (beacon, beaconId) => {
          return (
            <div style={{opacity: beacons && beacons[beaconId].showBeacon ? 1 : 0}}>
              <Joyride
                ref={c => (beacon.ref = c)}
                steps={beacon.steps}
                run
                disableOverlay
                callback={this.toggleBeacons}
                type={beacon.type}
                showSkipButton
                locale={locale}
              />
            </div>
          );
        })}
        <div id="welcome-step-anchor" style={{width: 0, height: 0, position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}/>
      </div>
    );
  }

}
